import { SAFEA_V3_ENABLED } from '~/constants/_core/safea-v3';

export default ({ route, redirect, store }) => {
  // The Safe A v3 IdP is responsible for the SAML authentication
  if (SAFEA_V3_ENABLED) {
    return;
  }

  const { state } = store;
  const {
    hasAuthBySaml,
    hasAuthBySafea,
    samlRequest
  } = state._core.application.authenticationsModes;

  const meta = route.meta || [];
  const { disableSaml } = meta.find(item => item.disableSaml) || {};

  // Get if the user is already authenticated or the saml is disabled
  const isNotSamlOrAlreadyAuthenticated = disableSaml || store.getters['_core/auth/isAuthenticated'] || route.query.tokenId;

  // If the user is not authenticated and the authMode is saml, we force the redirect to the saml login page
  if (route.query.authMode === 'saml' && samlRequest !== null && !isNotSamlOrAlreadyAuthenticated) {
    return redirect(samlRequest.url);
  }

  if (hasAuthBySafea || !hasAuthBySaml || samlRequest === null) {
    return;
  }

  // Case the user is already authenticated or the saml is disabled, redirect to login page
  if (isNotSamlOrAlreadyAuthenticated) {
    return;
  }

  return redirect(samlRequest.url);
};
